import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ScrollMargin } from './scroll-margin';

export const provideScrollMargin = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    // Initialize the Scroll Margin
    provideAppInitializer(() => {
      inject(ScrollMargin);
    }),
  ]);
